import { defaultFormValues, FormValues } from "../common/FormValues";
import { defaultDisabilityFormValues, DisabilityFormValues } from "./DisabilityFormValues";
import { Party } from "../enums/Party";
import { ConditionType } from "../enums/ConditionType";

export type PregnancyDisabilityPhysicianFormValues = FormValues & DisabilityFormValues & {
    patientFirstName: string,
    patientLastName: string,
    patientDateOfBirth: string,
    restrictionOrCareStartDate: string,
    diagnoses: [{
        diagnosisCode: string,
        diagnosis: string
    }],
    firstVisit: string,
    lastVisit: string,
    deliveryDate: string,
    expectedDelivery: boolean,
    bedConfined: boolean,
    bedConfinedStartDate: string,
    bedConfinedEndDate: string,
    physicianFirstName: string,
    physicianLastName: string,
    physicianDegree: string,
    physicianPhoneNumber: string,
    physicianStreetAddress: string,
    physicianCity: string,
    physicianState: string,
    physicianZipCode: string,
}

export const defaultPregnancyDisabilityPhysicianFormValues = {
    ...defaultFormValues,
    ...defaultDisabilityFormValues,
    party: Party.PHYSICIAN,
    patientFirstName: '',
    patientLastName: '',
    patientDateOfBirth: '',
    restrictionOrCareStartDate: '',
    diagnoses: [{
        diagnosisCode: '',
        diagnosis: ''
    }],
    firstVisit: '',
    lastVisit: '',
    conditionType: ConditionType.PREGNANCY,
    deliveryDate: '',
    expectedDelivery: false,
    bedConfined: false,
    bedConfinedStartDate: '',
    bedConfinedEndDate: '',
    physicianFirstName: '',
    physicianLastName: '',
    physicianDegree: '',
    physicianPhoneNumber: '',
    physicianStreetAddress: '',
    physicianCity: '',
    physicianState: '',
    physicianZipCode: '',
}